import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { FOOTER_STATUS, PHONE_DISPLAY, PHONE_HREF, WEBSITE } from "../../data/content";

export const Footer = () => (
  <footer className="grain relative overflow-hidden bg-[#1B241E] text-[#F4F1EA]" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-5 pb-10 pt-20 sm:px-8 lg:px-12">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Logo light />
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-[#C9CFC6]">
            Peer Support, CDCA Counseling and Life Coaching in Columbus, Ohio. In-person or by telehealth.
          </p>
        </div>
        <div className="grid grid-cols-2 gap-8 lg:col-span-7 lg:grid-cols-3">
          <div>
            <p className="font-mono-ui text-xs uppercase tracking-[0.2em] text-[#E9A88F]">Explore</p>
            <ul className="mt-4 space-y-3 text-sm text-[#DDE2DA]">
              <li><Link to="/services" className="hover:text-white" data-testid="footer-services-link">Services</Link></li>
              <li><Link to="/services#paying" className="hover:text-white" data-testid="footer-paying-link">Paying for Services</Link></li>
              <li><Link to="/faq" className="hover:text-white" data-testid="footer-faq-link">FAQ</Link></li>
              <li><Link to="/contact" className="hover:text-white" data-testid="footer-contact-link">Contact</Link></li>
            </ul>
          </div>
          <div>
            <p className="font-mono-ui text-xs uppercase tracking-[0.2em] text-[#E9A88F]">Your rights</p>
            <ul className="mt-4 space-y-3 text-sm text-[#DDE2DA]">
              <li><Link to="/privacy-practices" className="hover:text-white" data-testid="footer-npp-link">Notice of Privacy Practices</Link></li>
              <li><Link to="/client-rights" className="hover:text-white" data-testid="footer-client-rights-link">Client Rights &amp; Grievances</Link></li>
              <li><Link to="/nondiscrimination" className="hover:text-white" data-testid="footer-nondiscrimination-link">Nondiscrimination</Link></li>
              <li><Link to="/language-help" className="hover:text-white" data-testid="footer-language-help-link">Free Language Help</Link></li>
              <li><Link to="/services#paying" className="hover:text-white" data-testid="footer-gfe-link">Good Faith Estimate</Link></li>
            </ul>
          </div>
          <div>
            <p className="font-mono-ui text-xs uppercase tracking-[0.2em] text-[#E9A88F]">Reach us</p>
            <ul className="mt-4 space-y-3 text-sm text-[#DDE2DA]">
              <li><a href={PHONE_HREF} className="hover:text-white" data-testid="footer-phone-link">{PHONE_DISPLAY}</a></li>
              <li>33 S. Washington Ave Ste. N, Columbus, Ohio 43215</li>
              <li>In-person &amp; telehealth</li>
              <li data-testid="footer-website"><a href="https://www.surgevity.solutions" className="hover:text-white" rel="noreferrer">{WEBSITE}</a></li>
            </ul>
          </div>
          <div className="col-span-2 rounded-2xl border border-white/15 p-5 lg:col-span-1">
            <p className="font-mono-ui text-xs uppercase tracking-[0.2em] text-[#E9A88F]">In crisis?</p>
            <p className="mt-3 text-sm leading-relaxed text-[#DDE2DA]">
              Call or text <a href="tel:988" className="font-semibold text-white underline underline-offset-4" data-testid="footer-988-link">988</a> for the Suicide &amp; Crisis Lifeline, or call 911 in an emergency.
            </p>
          </div>
        </div>
      </div>
      <p className="font-serif-display mt-20 select-none text-[18vw] leading-[0.8] tracking-tight text-[#F4F1EA]/[0.07] lg:text-[13rem]" aria-hidden="true">
        Surgevity
      </p>
      <div className="mt-6 flex flex-col gap-4 border-t border-white/15 pt-6 text-xs leading-relaxed text-[#C9CFC6] md:flex-row md:items-start md:justify-between">
        <p className="max-w-3xl" data-testid="footer-status-statement">{FOOTER_STATUS}</p>
        <p className="shrink-0">© 2026 Surgevity Solutions</p>
      </div>
    </div>
  </footer>
);
